import { useConfig } from '#/hooks/useConfig';
import { CoreFooterFeature } from '#/service/config/features.types';

export type UseFooter = ReturnType<typeof useFooter>;

export const useFooter = () => {
  const {
    footer: legacyFooter,
    featureConfig: { footer },
  } = useConfig();

  /* 
    Use the the new footer if it's enabled and has sections, otherwise we fallback to the legacy JSON. 
    The solution isn't 100% optimal because a customer might want to use the new footer without sections,
    possible in the old solution due to enabled flag, which wont work with this implementation, but this 
    should help to not break customers current setup at least. Hopefully we can get a flag when Admin have 
    implemented the option on their side.  
  */
  const hasLegacyFooter = !footer?.sections?.length;

  const transformedLegacySections: CoreFooterFeature['sections'] =
    legacyFooter?.columns?.map((column) => ({
      key: column.key,
      display: { title: column.title },
      items: column.items.map((item) => ({
        key: item.key,
        display: { title: item.title },
        action: item.action,
      })),
    })) ?? [];

  const transformedLegacySocials: CoreFooterFeature['socials'] =
    legacyFooter?.socials?.map((social) => ({
      key: social.key.toUpperCase(),
      action: social.action,
    })) ?? [];

  return {
    enabled: hasLegacyFooter ? legacyFooter.enabled : true,
    copyright: hasLegacyFooter ? legacyFooter.copyright : footer.copyright,
    contact: hasLegacyFooter ? legacyFooter.contact : footer.contact,
    socials: hasLegacyFooter ? transformedLegacySocials : footer.socials,
    sections: hasLegacyFooter ? transformedLegacySections : footer.sections,
  };
};
